import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { CALYPSO, GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tile = styled.div.withConfig({
  displayName: "PropertiesFormDependentSection__Tile",
  componentId: "sc-5ybeft-0"
})(["position:relative;border-radius:3px;background-color:", ";border:1px solid ", ";border-left:solid 5px ", ";margin-top:16px;margin-bottom:8px;"], OLAF, GREAT_WHITE, CALYPSO);
const TileSection = styled.div.withConfig({
  displayName: "PropertiesFormDependentSection__TileSection",
  componentId: "sc-5ybeft-1"
})(["padding:16px;"]);
function PropertiesFormDependentSection({
  children,
  property
}) {
  return /*#__PURE__*/_jsx(Tile, {
    "data-test-id": `${property.name}-dependents`,
    children: /*#__PURE__*/_jsxs(TileSection, {
      children: [/*#__PURE__*/_jsx(Small, {
        weight: "medium",
        children: /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "propertiesForm.dependentFieldsHelp",
            options: {
              label: property.label
            }
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "propertiesForm.dependentFieldsTitle"
          })
        })
      }), children]
    })
  });
}
export default PropertiesFormDependentSection;